import React from 'react'
import PropTypes from 'prop-types'
import TableWithBackground from 'src/components/house/TableWithBackground'
import CloseIcon from 'src/assets/img/house/close.svg'

const HouseCommentDisplay = ({ open, onClose, comment }) => {
  if (!open) return null

  return (
    <div className="absolute inset-0 z-10 flex items-end justify-center px-6 pb-[30%]">
      <div className="relative w-full max-w-sm">
        <span className="absolute inset-0 rounded-[10px] -rotate-3 bg-[#694296B2]" />
        <span className="absolute inset-0 rounded-[10px] rotate-3 bg-[#F76B92B2]" />
        <TableWithBackground>
          <p className="w-full px-3 py-2 text-left text-xs xs:text-sm bg-white font-medium text-house-black tracking-wider font-ShinMaruGo min-h-[4rem]">
            {comment || '記載がない'}
          </p>
        </TableWithBackground>
        <button
          onClick={onClose}
          className="absolute -top-4 -right-4 z-20 w-10 h-10 hover:scale-105 transition-transform"
        >
          <img src={CloseIcon} alt="閉じる" className="w-full h-full" />
        </button>
      </div>
    </div>
  )
}

HouseCommentDisplay.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  comment: PropTypes.string,
  userName: PropTypes.string
}

export default HouseCommentDisplay
